export const useSnackbarStore = defineStore("snackbar", () => {
  const open = ref(false);
  const type = ref(null);
  const message = ref(null);
  const action = ref(null);
  const close = ref(false);

  return {
    open,
    type,
    message,
    action,
    close,
  };
});
